import { render, staticRenderFns } from "./diffinfo.vue?vue&type=template&id=14700225&scoped=true&"
import script from "./diffinfo.vue?vue&type=script&lang=js&"
export * from "./diffinfo.vue?vue&type=script&lang=js&"
import style0 from "./diffinfo.vue?vue&type=style&index=0&id=14700225&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14700225",
  null
  
)

export default component.exports